export default __webpack_public_path__ + "static/media/1795.9af7a18e.png";